import type { IconProps } from '../icons/types';

export function GoogleSheetsIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <rect width="18" height="18" x="3" y="3" rx="2" fill="#0F9D58" />
      <path d="M7 8h10M7 12h10M7 16h10" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
      <path d="M11 8v8" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function GoogleDriveIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <path d="M8.2 3.5h7.6l6 10.4-3.8 6.6H10.4L8.2 3.5Z" fill="#FFC107" />
      <path d="M2.2 13.9 6 7.3l3.8 6.6-3.8 6.6H2.2l3.8-6.6Z" fill="#2196F3" opacity="0.9" />
      <path d="M6 20.5h15.8l-3.8-6.6H2.2L6 20.5Z" fill="#4CAF50" />
    </svg>
  );
}

export function GoogleCalendarIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <rect width="18" height="18" x="3" y="3" rx="2" fill="#1A73E8" />
      <rect width="14" height="10" x="5" y="9" rx="1" fill="#FFFFFF" />
      <circle cx="8" cy="12" r="1" fill="#1A73E8" />
      <circle cx="12" cy="12" r="1" fill="#1A73E8" />
      <circle cx="16" cy="12" r="1" fill="#1A73E8" />
      <circle cx="8" cy="15" r="1" fill="#1A73E8" />
      <circle cx="12" cy="15" r="1" fill="#1A73E8" />
      <circle cx="16" cy="15" r="1" fill="#1A73E8" />
      <path d="M7 2v2M17 2v2" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function GoogleContactsIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <rect width="18" height="18" x="3" y="3" rx="2" fill="#4285F4" />
      <circle cx="12" cy="10" r="3.5" fill="#FFFFFF" />
      <path
        d="M6 18c0-2.5 2.5-4 6-4s6 1.5 6 4"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
